
export const typeParam= 'ai_param_info'

export interface IParam  {  
    key: string;  
    type: string;  
    value?: any;
    
    desc?:string;
    ctx_var?:string;
    src_id?:string;
    src_key?:string;
    unchanged?:boolean;
}

export type Param = {  
    key: string;  
    type: string;  
    value?: any;
    desc?:string;
    ctx_var?:string;
    src_id?:string;
    src_key?:string;
    unchanged?:boolean;
    
} 

